<template>
	<div class="sm_star">
		<!-- <div class="d-flex flex-column t-center " style="background-color:#2D6DCC;height:100vh;"  v-if="!file">
				<img src="/images/board/image-view.png" style="margin-top:40%;">
			</div> -->
			<div v-if="file" class="mdc-dialog" data-mdc-auto-init="MDCDialog" style="display: block; z-index:999;">
			<div id="attched-close-button" class="attched-close-button" style="z-index:999;">
				<img alt="" class="cursor-pointer w-48 h-48 attched-close-button" src="/images/close-button.svg" tabindex="0" @click="hideImage" @keypress="hideImage">
			</div>
			<div class="mdc-dialog__container" style="opacity:1; transform: scale(1);">
				<div v-if="type === 'lessonChat'" aria-modal="true" class="mdc-dialog__surface home-modal" role="alertdialog">
					<img :alt="file.originalName" :src="file.resourceUri" class="b-radius4"/>
				</div>
				<div v-else aria-modal="true" class="mdc-dialog__surface home-modal" role="alertdialog">
					<img v-if="type === 'lessonChat'" :alt="file.originalName" :src="file.resourceUri" class="b-radius4"/>
					<img v-if="getType(file.contentType) === 'image'" :alt="file.originalName" :src="file.resourceUri" class="b-radius4 modal-preview-image"/>
					<video-player
							v-if="getType(file.contentType) === 'video'"
							ref="videoPlayer"
							:options="getPayerOption(file)"
							:playsinline="true"
							class="video-player-box vjs-custom-skin preview-video-new"
					/>
					<!-- {{type}} -->
				</div>
			</div>
			<div class="mdc-dialog__scrim" style="opacity:1;" tabindex="0" @click="hideImage" @keypress="hideImage"></div>
		</div>
	</div>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import {MDCRipple} from '@material/ripple'
import {topAppBarMixin} from "@/mixins/topAppBar";

export default {
	components: {videoPlayer},

	props:['file', 'type'],

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseSocialPopup('');
    this.setMaterialUi();
  },

	methods : {
		getType(contentType) {
			return contentType.split('/')[0]
		},

		hideImage() {
			this.$emit('closePopup')
		},

		getPayerOption(img) {
			return {
				//muted: true,
				language: 'en',
				controls: true,
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [{
				type: img.contentType,
				src: img.resourceUri
				}],
				//height: ($(window).height()-100),
				height: 360,
				width: 'auto'
			}
		},
		setMaterialUi() {
				const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
					let button = new MDCRipple.attachTo(el)
					return button
				})
			},
	}
}
</script>

<style scoped>
.vjs-big-play-button {
	left: 50% !important;
	top: 50% !important;
	transform: translate(-50%, -50%);
	width: 80px!important;
	height: 80px!important;
	-webkit-border-radius: 0.8em!important;
	-moz-border-radius: 0.8em!important;
	border-radius: 1.9em!important;
	font-size: 5em!important;
	background-color: transparent !important;
	border: none !important;
}

.image-view-container img {
	object-fit: cover;
}

.mdc-top-app-bar .mdc-top-app-bar__action-item, .mdc-top-app-bar .material-icons.blue0006 { color: #212121 !important }

.home-modal {
  min-width: auto !important;
}
.home-modal .video-js{
	right: 0 !important;
}
</style>
